// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthenticationImage_wrapper__4yNEz","form":"AuthenticationImage_form__Uf56c","title":"AuthenticationImage_title__fsrgw"};